import { useMutation, useQueryClient } from "react-query";
import { mutatePatchFn } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export const useResolveFlaggedEmail = () => {
  const queryClient = useQueryClient();
  return useMutation<any, any, { id: string }>(
    ({ id }) => mutatePatchFn(
      ENDPOINTS.FLAGGED_EMAIL_RESOLVE.replace(":id", id),
      {}
    ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ENDPOINTS.FLAGGED_EMAILS]);
      },
    }
  );
};
